<template>
  <div class="mybox">
    <home-header :isShow="true"></home-header>
    <div class="mycenter">
      <el-row :gutter="20">
        <el-col :span="6">
          <div class="grid-content bg-purple left">
            <!-- <el-avatar :size="80" :src='user.head_portrait'>
              <img src="@/assets/images/headerImg.jpg"/>
            </el-avatar> -->
            <el-image class="avatar" :src="user.head_portrait" fit="cover">
              <img class="avatar_img" slot="error" src="@/assets/images/headerImg.jpg" alt="" />
            </el-image>
            <div class="username">{{ user.nickname }}</div>
            <router-link class="edit-btn" to="/edituserinfo">
              编辑资料</router-link
            >
          </div>
          <div class="btns_list">
            <left-list :activeIndex="activeIndex"></left-list>
          </div>
        </el-col>
        <el-col :span="18">
          <div class="grid-content my_right">
            <comment-title titleText="绑定微信" :isShow="false"></comment-title>
            <div class="wx_details" v-if="is_bind">
              <img :src="user.head_portrait" />
              <div class="username">{{ user.nickname }}</div>
              <el-button
                class="unbind"
                type="primary"
                plain
                size="small"
                @click="UnBind"
                >解除绑定</el-button
              >
            </div>
            <div class="wx_details" v-else>
              <wxlogin
                class="img"
                appid="wx08ce7cf7c8886e10"
                :scope="'snsapi_login'"
                :theme="'black'"
                :redirect_uri="encodeURIComponent(redirect_url)"
                :href="'data:text/css;base64,LmV3bSAuaW1newogIHdpZHRoOiA0MDBweDsKICBoZWlnaHQ6IDMwMHB4OwogIG1hcmdpbjogMCBhdXRvOwp9Ci5pbXBvd2VyQm94IC5xcmNvZGUge3dpZHRoOiAyMjBweDt9Ci5pbXBvd2VyQm94IC50aXRsZSB7ZGlzcGxheTogbm9uZTt9'"
                rel="external nofollow"
              >
              </wxlogin>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <home-footer></home-footer>
  </div>
</template>
<script>
// import HomeHeader from '@/components/Header'
import HomeHeader from "@/components/homeHeader";

import HomeFooter from "@/components/Footer";
import CommentTitle from "@/components/Title";
import LeftList from "../components/LeftList";
import wxlogin from "vue-wxlogin";

export default {
  name: "BindWeChat",
  components: {
    HomeHeader,
    HomeFooter,
    CommentTitle,
    LeftList,
    wxlogin,
  },
  data() {
    return {
      user: JSON.parse(localStorage.getItem("user")),
      activeIndex: "3",
      is_bind: false,
      redirect_url: window.location.href,
    };
  },
  created() {
    this.IsBind();
    // this.clearQuery()
  },
  methods: {
    IsBind() {
      this.$api
        .wechatIsBind()
        .then((res) => {
          //数据处理
          this.is_bind = res.data.is_bind;
        })
        .catch((err) => console.log(err));
    },
    UnBind() {
      this.$api
        .wechatUnBind()
        .then((res) => {
          //数据处理
          this.$alert("解绑成功", "提示", {
            confirmButtonText: "确定",
            callback: (action) => {
              let path = this.$route.path; //先获取路由路径
              this.$router.push(path); //再跳转路由路径，query参数没带过去，所以被清除了
              window.location.reload();
            },
          });
        })
        .catch((res) => {
          this.$message.error(res.message);
        });
    },
    clearQuery() {
      this.$router.push({
        query: "",
      });
    },
  },
  watch: {
    $route: {
      handler() {
        this.code = this.$route.query.code;
        console.log(this.code);
        if (this.code) {
          this.$api
            .wechatBind({ code: this.code })
            .then((res) => {
              localStorage.setItem("token", res.data.access_token);
              localStorage.setItem("user", JSON.stringify(res.data.member));
              this.$alert("绑定成功", "提示", {
                confirmButtonText: "确定",
                callback: (action) => {
                  let path = this.$route.path; //先获取路由路径
                  this.$router.push(path); //再跳转路由路径，query参数没带过去，所以被清除了
                  window.location.reload();
                },
              });
            })
            .catch((err) => {
              if (err.code == 422) {
                this.$alert(err.message, "提示", {
                  confirmButtonText: "确定",
                  callback: (action) => {
                    let path = this.$route.path; //先获取路由路径
                    this.$router.push(path); //再跳转路由路径，query参数没带过去，所以被清除了
                    window.location.reload();
                  },
                });
              }
              console.log(err);
            });
        }
        //深度监听，同时也可监听到param参数变化
      },
      deep: true,
    },
  },
};
</script>
<style scoped>
.mybox {
  background: #f3f3f3;
}

.mycenter {
  width: 1200px;
  margin: 20px auto;
}

.left {
  height: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: white;
  margin-bottom: 20px;
  border-radius: 10px;
}

.left .el-avatar {
  margin-top: 40px;
}
.left .avatar {
  margin-top: 40px;
}
.avatar {
  /* margin-left: 59px; */
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background-color: #58b75b;
  overflow: hidden;
}
.left .avatar .avatar_img{
                  width: 80px;
        height: 80px;
        border-radius: 50%;
          object-fit: cover;
        }

.left .username {
  font-size: 20px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #333333;
  margin: 40px auto;
}

.my_right {
  background: white;
  padding: 40px 0px 40px 0px;
  border-radius: 10px;
}

.wx_details img {
  width: 120px;
  height: 120px;
  background: #58b75b;
  border-radius: 50%;
  margin-bottom: 10px;
}

.wx_details {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 40px 0px;
}

.wx_details .title {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
}
.unbind {
  margin-top: 20px;
}

.edit-btn {
  width: 100px;
  height: 40px;
  border: 1px solid #999999;
  border-radius: 20px;
  line-height: 40px;
  text-align: center;
  color: #999999;
  margin-bottom: 60px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/my/Pages/BindWeChat.vue